'use es6';

import GoodFiltersAndPage from './GoodFiltersAndPage';
export default [GoodFiltersAndPage.LIMIT, GoodFiltersAndPage.PAGE];